import type { GtagSanitizedParams } from "./types";

const isValidValue = (value: unknown): boolean => {
	const type = typeof value;
	return (
		value !== null &&
		value !== undefined &&
		type !== "object" &&
		type !== "function"
	);
};

const convertValue = (value: unknown): string | number | boolean => {
	const type = typeof value;
	if (type === "number") {
		return value as number;
	}
	if (type === "boolean") {
		return value ? "true" : "false";
	}
	return String(value);
};

export const sanitizeParams = (
	params: Record<string, unknown> = {}
): GtagSanitizedParams => {
	const entries = Object.entries(params).filter(([, value]) =>
		isValidValue(value)
	);
	return Object.fromEntries(
		entries.map(([key, value]) => [key, convertValue(value)])
	);
};
